/** The portal's top navigation, in order, matching the portal prototype. */
export interface PortalNavItem {
  key: string;
  label: string;
  path: string;
}

export const PORTAL_NAV: readonly PortalNavItem[] = [
  { key: "home", label: "Home", path: "/home" },
  { key: "referrals", label: "Referrals", path: "/referrals" },
  { key: "assets", label: "Assets", path: "/assets" },
  { key: "payouts", label: "Payouts", path: "/payouts" },
  { key: "profile", label: "Profile", path: "/profile" },
];
